// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_ENLIGHTENED = [{
  id: 'enlightened_alchemy',
  factionId: FACTIONS.ENLIGHTENED,
  name: 'Алхимик',
  priceNumens: 35000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.YELLOW,
  ]
}, {
  id: 'enlightened_diplomacy',
  factionId: FACTIONS.ENLIGHTENED,
  name: 'Дипломат Света',
  priceNumens: 43000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.ORANGE,
  ]
}, {
  id: 'enlightened_shadow',
  factionId: FACTIONS.ENLIGHTENED,
  name: 'Мастер Теней',
  priceNumens: 90000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.BLUE,
  ]
}, {
  id: 'enlightened_gold_legacy',
  factionId: FACTIONS.ENLIGHTENED,
  name: 'Хранитель заветов',
  priceNumens: 70000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'enlightened_ruby_legacy',
  factionId: FACTIONS.ENLIGHTENED,
  name: 'Багряный иерарх',
  priceCrystals: 450,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
